export default angular.module('FrontRoyal.Linkedin', []);
